import React, { Component } from 'react';
import Button from "./Button";
import ButtonList from "./ButtonList";
import UserCard from "./UserCard";
import Actions from "./Actions";
import RadioButton from "./RadioButton";
import HyperLink from "./HyperLink";
import Checkbox from "./Checkbox";
import Setting from "./Setting";
import PopHoverLink from "./PopHoverLink";
import SwitchButton from "./SwitchButton";
import Image from "./Image";
import Activity from "./Activity";
import GridActionWithCheckBox from "./GridActionWithCheckBox";
import Status from "./Status";
import OtherComponent from './OtherComponent';
import UploadStatus from "./UploadStatus";
// import {isSet} from '../../../../Utils/CommonFunctions';
// import Wrp from '../../../../hoc/Wrp/Wrp';
import InputElement from './InputElement';
import HtmlWithLink from './HtmlWithLink';
import {isSet} from '../../../../Utils/CommonFunctions';
import Barcode from './Barcode';
import ActiveInActive from './ActiveInActive';
import RadioButtonWithHandler from './RadioButtonWithHandler';
import HtmlPreviewData from './HtmlPreviewData';
class TableData extends Component {
    
    render () {
        const {header} = this.props
        // console.log(this.props.colData,this.props.header.type);
        switch (isSet(header.type,'')) {
            case "Button":  
            //Button type column
                return <Button {...this.props} 
               />;
            case "Button List":  
               //Button type column
                   return <ButtonList {...this.props} 
                  />;
            case "PopHoverLink":  
               //Popup Hover eg: profile
                return <PopHoverLink {...this.props} 
                  />; 
            case "Activity":  
                  //Popup Hover eg: profile
                return <Activity {...this.props} 
                     />;         
            case "Setting":  
               //Setting Hover with action more
                if(this.props.colData.value || this.props.colData.value === '')
                 return <Setting {...this.props} 
                    />;
                else 
                 return <td key={"column"+this.props.id}>{this.props.colData}</td>;
            case "UploadStatus":
                return <UploadStatus {...this.props} />           
            case "RadioButton":
                //Button type column
                return <RadioButton {...this.props} 
                   />;
            case "RadioButtonWithHandler":
                //Button type column
                return <RadioButtonWithHandler {...this.props} 
                   />;
            case "GridActionWithCheckBox":
                //Grid Action With checkbox
                return <GridActionWithCheckBox {...this.props} 
                       />;       
            case "Checkbox":
                //Button type column
                return <Checkbox {...this.props} 
                       />;
            case "HyperLink":
                //Button type column
                return <HyperLink {...this.props} 
                       />;          
            case "UserCard":
            //User Name,Image and status column
                return <UserCard {...this.props}  />;
            case "Actions":
                //User Name,Image and status column
                return <Actions {...this.props}  />;  
            case "Switch":  
                //SwitchButton type column ON/OFF
                return <SwitchButton {...this.props} />;  
            case "Status":  
                //Switch status on / off
                return <Status {...this.props} />;  
            case "Image":
                return <Image {...this.props} />;
            case "HtmlWithLink":
                return <HtmlWithLink {...this.props} />;   
            case "Barcode":
                return <Barcode {...this.props} />;
            case "ActiveInActive":
                return <ActiveInActive {...this.props} />;
            case "Others":
                return <OtherComponent {...this.props}/>;
            case "InputElement":
                return <InputElement {...this.props} />
            case "HtmlPreviewData":
                return <HtmlPreviewData {...this.props} />   
            case "NoHref":
                return <td key={"column"+this.props.id} title={this.props.colData.value}><span className="tbodyTitle">{this.props.colData.value}</span></td>;  
            default:
                return <td key={"column"+this.props.id} title={(this.props.colData && this.props.colData.value)?this.props.colData.value:this.props.colData}>{isSet(this.props.colData,'')}</td>
          }

    }
}

TableData.defaultProps = {
    header:{
        type:''
    }
}
export default TableData;